import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ResultCard from './ResultCard';
import { parseDate } from '../helpers/DateUtils';
import { hasResultsAndActivated } from '../helpers/EventUtils';
import './Landing.css';

const LatestResultsSection = ({ events, filterText }) => {
  // Process and filter events
  const processedResults = useMemo(() => {
    if (!events || events.length === 0) {
      return [];
    }

    const now = new Date();
    const threeDaysAgo = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000);

    // Filter events with results and activated status
    let filteredEvents = events.filter((event) =>
      hasResultsAndActivated(event) &&
      event.event_results &&
      event.event_results !== 'available after competition'
    );

    // Apply search/filter text
    if (filterText && filterText.trim() !== '') {
      const searchLower = filterText.toLowerCase();
      filteredEvents = filteredEvents.filter(
        (event) =>
          (event.event_club && event.event_club.toLowerCase().includes(searchLower)) ||
          (event.event_location && event.event_location.toLowerCase().includes(searchLower))
      );
    }

    // Sort by date descending (most recent first)
    filteredEvents = filteredEvents.sort((a, b) => {
      try {
        const dateA = parseDate(a.event_year, a.event_month, a.event_day);
        const dateB = parseDate(b.event_year, b.event_month, b.event_day);
        return dateB - dateA; // Descending order
      } catch (e) {
        return 0;
      }
    });

    // Take first 12 results (displays nicely in 3-column grid)
    filteredEvents = filteredEvents.slice(0, 12);

    // Determine which results are "New" (within last 3 days)
    const resultsWithNewFlag = filteredEvents.map((event) => {
      try {
        const eventDate = parseDate(event.event_year, event.event_month, event.event_day);
        const isNew = eventDate >= threeDaysAgo && eventDate <= now;
        return { ...event, isNew };
      } catch (e) {
        return { ...event, isNew: false };
      }
    });

    return resultsWithNewFlag;
  }, [events, filterText]);

  return (
    <div className="landing-container">
      <h2 className="section-title">Latest Results</h2>

      {processedResults.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666', padding: '40px 0' }}>
          No results found. Try adjusting your filter.
        </p>
      ) : (
        <div className="results-grid">
          {processedResults.map((event) => (
            <ResultCard key={event.event_id} event={event} isNew={event.isNew} />
          ))}
        </div>
      )}

      <div className="view-all-link">
        <Link to="/events/results">View All Results →</Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  events: state.events,
});

export default connect(mapStateToProps)(LatestResultsSection);
